import * as actionTypes from "@mds/common/constants/actionTypes";


// eslint-disable-next-line import/prefer-default-export
export const storeExplosivesPermits = (payload) => ({
  type: actionTypes.STORE_EXPLOSIVES_PERMITS,
  payload,
});
